import { render, staticRenderFns } from "./CrewCombinationsSummary.vue?vue&type=template&id=1c85965a&scoped=true"
import script from "./CrewCombinationsSummary.vue?vue&type=script&lang=js"
export * from "./CrewCombinationsSummary.vue?vue&type=script&lang=js"
import style0 from "./CrewCombinationsSummary.vue?vue&type=style&index=0&id=1c85965a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85965a",
  null
  
)

export default component.exports